import { isNil, omitBy } from 'lodash';

const response = (data: any) => {
  return omitBy(
    {
      ...data,
      items: data.items?.map((item) => {
        const foundInventoryData = data.inventoryData?.find((inv) => inv._id === item.inventoryID);
        return omitBy(
          {
            ...item,
            itemData: foundInventoryData,
          },
          isNil,
        );
      }),
    },
    isNil,
  );
};

export default response;
